<template>
    <LayoutSub>
        <SubSection classList="pb-0" v-if="data">
            <ListNormalPage :data="data" />
        </SubSection>
        <LoadingWrap v-else />
    </LayoutSub>
</template>

<script>
import { getElectronicList } from '@/api';
import LoadingWrap from '@/components/LoadingWrap.vue';
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';
import ListNormalPage from '@/views/common/ListNormalPage.vue';

export default {
    components: {
        LayoutSub,
        ListNormalPage,
        LoadingWrap,
        SubSection,
    },
    data() {
        return {
            data: null,
        };
    },
    async mounted() {
        await this.getList();
    },
    watch: {
        async $route() {
            await this.getList();
        },
    },
    methods: {
        async getList() {
            try {
                const { paging: data } = await getElectronicList(this.$route.query);

                this.data = data;
            } catch (err) {
                if (!this.data) this.data = null;
            }
        },
    },
};
</script>
